var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtsOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.66667C8 8.29848 8.29848 8 8.66667 8H10C10.3682 8 10.6667 8.29848 10.6667 8.66667V15.3333C10.6667 15.7015 10.3682 16 10 16H8.66667C8.29848 16 8 15.7015 8 15.3333V8.66667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.66667C13.3333 8.29848 13.6318 8.00001 14 8.00001H15.3333C15.7015 8.00001 16 8.29848 16 8.66667V15.3333C16 15.7015 15.7015 16 15.3333 16H14C13.6318 16 13.3333 15.7015 13.3333 15.3333V8.66667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtsOff);
export default __webpack_public_path__ + "static/media/tts_off.fc141fd41cf84614a63e3c6e9da078f5.svg";
export { ForwardRef as ReactComponent };